<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet color="white" class="pa-5" rounded>
          <h3>لیست آزمون ها</h3>
          <v-data-table
            :items="answersheets"
            :headers="answersheetHeaders"
            :items-per-page="15"
            :loading="loading"
            loading-text="در حال بررسی ..."
          >
            <template v-slot:[`item.createDate`]="{ item }">
              <persian-date :date="item.createDate" />
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";

export default {
  name: "my-exams-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      loading: true,
      answersheets: [],
      answersheetHeaders: [
        { text: "کتاب", value: "book", align: "center" },
        { text: "پایه", value: "grade", align: "center" },
        { text: "زمان ثبت آزمون", value: "createDate", align: "center" },
        { text: "نمره کل (%)", value: "totalScore", align: "center" },
        { text: "نمره تمرکز  (%)", value: "focusScore", align: "center" },
        { text: "نمره استنباط  (%)", value: "inferenceScore", align: "center" },
        {
          text: "نمره تفسیر  (%)",
          value: "interpretationScore",
          align: "center"
        },
        { text: "نمره ارزیابی  (%)", value: "assessmentScore", align: "center" }
      ]
    };
  },
  created() {
    this.handleGetAnswersheets();
  },
  methods: {
    handleGetAnswersheets() {
      this.$api.get("answerSheets").then((res) => {
        this.answersheets = res.data.answerSheet;
        this.loading = false;
      });
    }
  }
};
</script>
